import { createSlice } from "@reduxjs/toolkit";
import { getNotification } from "./Notification.api";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    notification: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNotification.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getNotification.fulfilled, (state, action) => {
      state.loading = false;
      state.notification = action.payload;
      state.dataLimit = action.payload?.meta?.limit || 0;
      state.currentPage = action.payload?.meta?.page || 1;
      state.totalPages = action.payload?.meta?.totalPages || 0;
      state.totalData = action.payload?.meta?.totalUniqueTitles || 0;
    });
    builder.addCase(getNotification.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { resetState } = notificationSlice.actions;
export default notificationSlice.reducer;
